import { GeneralTable } from "@/shared/components/ui";
import { useMemo, useState } from "react";
import { useTableColumnsConsultasPorNap } from "./useTableColumnsConsultasPorNap";

type TablaConsultasPorNapProps = {
    allData: any;
    isLoading: boolean;
};

export default function TablaConsultasPorNap({
    allData,
    isLoading,
}: TablaConsultasPorNapProps) {

    // Paginación para Material React Table (manejada internamente por la tabla)
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });

    const filteredData = useMemo(() => {
        let data = allData;
        return data;
    }, [allData]);

    const paginatedData = useMemo(() => {
        const startIdx = pagination.pageIndex * pagination.pageSize;
        const endIdx = startIdx + pagination.pageSize;
        return filteredData.slice(startIdx, endIdx);
    }, [filteredData, pagination.pageIndex, pagination.pageSize]);

    const {
        columnBase,
    } = useTableColumnsConsultasPorNap({ pagination });

    return (
        <>
            <GeneralTable
                columns={columnBase}
                data={paginatedData}
                isLoading={isLoading}
                pagination={pagination}
                onPaging={setPagination}
                rowCount={filteredData.length}
                enableColumnActions={false}
                enableEditing={false}
                enableGlobalFilter={false}
                enableColumnFilters={true}
            />
        </>
    )
}